<script>
import LayoutMain from "@/router/layouts/main";
import LayoutExperts from "@/router/layouts/experts";
import { api } from "@/state/services";
import ExpertsPlanCard from "@/components/widgets/experts-plan-card";

// Confirmação do plano escolhido antes de gerar a fatura
export default {
  components: {
    LayoutMain,
    LayoutExperts,
    ExpertsPlanCard,
  },
  data() {
    return {
      loading: true,
      errored: false,
      submitting: false,

      plan: null,
      current: null,
      pending: null,
    };
  },
  computed: {
    // Sem plano do Experts ativo usa o layout sem menu; com plano ativo mantém o menu
    layout() {
      const user = this.$store.state.account.user;
      return user && user.expert == 'active' ? 'LayoutMain' : 'LayoutExperts';
    },
    // buy: primeira contratação; change: troca da fatura pendente; upgrade: plano ativo
    mode() {
      if (this.current) {
        return 'upgrade';
      }
      if (this.pending) {
        return 'change';
      }
      return 'buy';
    },
    // O plano escolhido pode ser contratado nesta situação?
    allowed() {
      if (!this.plan) {
        return false;
      }
      if (this.current && this.plan.type <= this.current.type) {
        return false;
      }
      return true;
    },
    title() {
      if (this.mode == 'upgrade') {
        return 'Confirme o seu upgrade';
      }
      if (this.mode == 'change') {
        return 'Confirme a troca do plano';
      }
      return 'Confirme o seu plano';
    },
  },
  methods: {
    load() {
      this.loading = true;
      this.errored = false;

      Promise.all([api.get('experts'), api.get('experts/current')])
        .then(([plans, current]) => {
          if (plans.data.status == 'success') {
            this.plan = plans.data.list.find(row => row.id == this.$route.params.id) || null;
          }
          if (current.data.status == 'success') {
            this.current = current.data.plan;
            this.pending = current.data.pending;
          }

          // Fatura pendente do mesmo plano: segue direto para o pagamento
          if (this.pending && this.plan && this.pending.plan.id == this.plan.id && this.pending.status == 'pending') {
            this.$router.replace('/experts/order/' + this.pending.order.id);
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    confirm() {
      this.submitting = true;

      api
        .post('experts', { id: this.plan.id })
        .then(response => {
          if (response.data.status == 'success') {
            this.$router.push('/experts/order/' + response.data.order.id);
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .catch(() => {
          this.$toast.error('Não foi possível gerar a fatura, tente novamente.');
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <component :is="layout">
    <div class="experts">
      <router-link to="/experts" class="experts-back">
        <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> Voltar aos planos
      </router-link>

      <div v-if="loading" class="text-center py-5">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else-if="errored" class="text-center py-5">
        <p>Pedimos desculpas, não podemos recuperar as informações neste momento.</p>
        <button class="btn btn-default" v-on:click="load()">Tentar novamente</button>
      </div>
      <div v-else-if="!plan || !allowed" class="text-center py-5">
        <p>Este plano não está disponível para você.</p>
        <router-link tag="a" to="/experts" class="btn btn-default">Ver planos</router-link>
      </div>
      <div v-else>
        <div class="experts-intro">
          <h1 class="experts-title">{{ title }}</h1>
          <p class="experts-subtitle">Revise os detalhes abaixo. Na próxima tela você escolhe como pagar.</p>
        </div>

        <div class="experts-confirm">
          <ExpertsPlanCard :plan="plan" :recommended="plan.type == 3" />

          <div class="experts-box experts-summary">
            <h5 class="mb-3">Resumo</h5>
            <dl>
              <div>
                <dt>Plano</dt>
                <dd>{{ plan.name }}</dd>
              </div>
              <div>
                <dt>Vigência</dt>
                <dd>12 meses</dd>
              </div>
              <div>
                <dt>Início</dt>
                <dd>Na confirmação do pagamento</dd>
              </div>
              <div>
                <dt>Pagamento</dt>
                <dd>PIX ou cartão de crédito</dd>
              </div>
              <div class="is-total">
                <dt>Total</dt>
                <dd>{{ plan.value | currency }}</dd>
              </div>
            </dl>

            <div v-if="mode == 'change'" class="experts-note">
              <i class="bx bx-info-circle" aria-hidden="true"></i>
              <span>A fatura atual do plano <strong>{{ pending.plan.name }}</strong> será cancelada e uma nova será gerada.</span>
            </div>
            <div v-if="mode == 'upgrade'" class="experts-note">
              <i class="bx bx-info-circle" aria-hidden="true"></i>
              <span>Seu plano <strong>{{ current.name }}</strong> será substituído. A nova vigência de 12 meses começa na confirmação do pagamento, sem crédito do plano atual.</span>
            </div>

            <button class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="confirm()" :disabled="submitting">
              Gerar fatura e pagar
              <b-spinner v-if="submitting" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
            </button>
            <router-link tag="a" to="/experts" class="btn btn-outline-default btn-lg btn-block text-uppercase mt-2">Escolher outro plano</router-link>
          </div>
        </div>
      </div>
    </div>
  </component>
</template>
